import { render } from "./CatalogProducts.vue?vue&type=template&id=05a268e7"
import script from "./CatalogProducts.vue?vue&type=script&lang=js"
export * from "./CatalogProducts.vue?vue&type=script&lang=js"

import "./CatalogProducts.vue?vue&type=style&index=0&id=05a268e7&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__